import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { prepareExperiments } from '../experiments';
import { prepareFormInitialState } from '../formInitialState';
import { EFormFieldsNames } from '../../types/requestForm';
import * as persistentState from '../../utils/persistentState';
export function prepareInitialState(preloadedState) {
  if (!preloadedState) {
    return {
      initialState: undefined,
      internalPreloadedFormState: undefined
    };
  }
  var _preloadedState$withH = preloadedState.withHelpLinks,
    withHelpLinks = _preloadedState$withH === void 0 ? true : _preloadedState$withH,
    _preloadedState$withA = preloadedState.withAgreement,
    withAgreement = _preloadedState$withA === void 0 ? true : _preloadedState$withA,
    experiments = preloadedState.experiments,
    referenceLink = preloadedState.referenceLink;

  // Формируем состояние формы, в зависимости от входных параметров виджета
  var preloadedFormState = _objectSpread(_objectSpread({}, preloadedState), {}, _defineProperty({}, EFormFieldsNames.AbstractWithPrivacyPolicy, withAgreement));

  // Формируем состояние формы, в зависимости от данных, сохраненных в localStorage
  var restoredFormState = persistentState.restore();
  var mergedFormState = _objectSpread(_objectSpread({}, restoredFormState), preloadedFormState);
  return {
    initialState: {
      helpLinks: {
        hidden: !withHelpLinks
      },
      experiments: prepareExperiments(experiments),
      referenceLink: referenceLink,
      formInitialState: prepareFormInitialState(mergedFormState)
    },
    internalPreloadedFormState: preloadedFormState
  };
}